import { Auth } from '@aws-amplify/auth';

export const signUpService = {
    signUp,
    signUpConfirm,
};

export const signUp = (
    firstName,
    lastName,
    companyName,
    username,
    password,
    errorMessageHandler
) => {
    return new Promise((resolve, reject) => {
        Auth.signUp({
            username,
            password,
            attributes: {
                email: username,
                given_name: firstName,
                family_name: lastName,
                'custom:customer_name': companyName,
            },
            validationData: [], //optional
        })
            .then(data => {
                //console.log(data);

                return resolve(data);
            })
            .catch(err => {
                console.error(err, errorMessageHandler);

                if (err.code === 'ExpiredCodeException') {
                    Auth.resendSignUp(username);
                    errorMessageHandler(
                        'Confirmation code expired. A new confirmation code has been emailed to you.'
                    );
                } else {
                    errorMessageHandler(err.message);
                }

                return reject(err.message);
            });
    });
};

export const signUpConfirm = (username, code, errorMessageHandler) => {
    //console.log('signUpConfirm', username, code);

    return new Promise((resolve, reject) => {
        Auth.confirmSignUp(username, code, {
            // Optional. Force user confirmation irrespective of existing alias. By default set to True.
            forceAliasCreation: true,
        })
            .then(data => {
                //console.log(data);

                return resolve(data);
            })
            .catch(err => {
                console.error(err, errorMessageHandler);
                errorMessageHandler(err.message);

                return reject(err.message);
            });
    });
};
